<script context="module">
  import { writable } from "svelte/store";
  let state = writable({
    isMobile: false
  });
</script>

<script>
  import PageComponent from "./components/PageComponent.svelte";
  import StickerComponent from "./components/StickerComponent.svelte";
  import { onMount } from "svelte";

  let pageData;
  let allPageComponents = [];
  let pageSlots = [];
  let pageComponentOrder = [];
  let visibleInNavPages = [];

  let width = window.innerWidth;
  let height = window.innerHeight;
  let isMobile = window.innerWidth < 700 ? true : false;
  let isStickersVisible = false;

  let stickerItems = [
    {
      img: "./assets/nice-test.png",
      rotation: -10,
      position: { x: width * 0.5, y: height * 0.2 },
      delay: 400,
      isButton: false
    },
    {
      img: "./assets/sausage-test.png",
      rotation: 18,
      position: { x: width * 0.6, y: height * 0.5 },
      delay: 800,
      isButton: false
    },
    {
      img: "./assets/hair-test.png",
      rotation: 0,
      position: { x: width * 0.7, y: height * 0.18 },
      delay: 1200,
      isButton: false
    },
    {
      img: "./assets/oval-icon.png",
      rotation: 0,
      position: { x: width * 0.8, y: height * 0.5 },
      delay: 1600,
      isButton: true
    }
  ];

  //Helper function to return array with items in new order
  function returnShuffledArray(arr, from, to) {
    const _arr = arr.slice(0);
    const val = _arr[from];
    _arr.splice(from, 1);
    _arr.splice(to, 0, val);
    return _arr;
  }

  //Receiving all pages from Storyblok CMS
  function getAllStories() {
    window.storyblok.getAll(
      {},
      (data, xhrResponse) => {
        var total = xhrResponse.getResponseHeader("Total");
        pageData = data.stories;
        //Filtering out pages that should not show in nav (e.g. blog posts)
        // visibleInNavPages = pageData.filter(page => page.content.inNavigation);
        visibleInNavPages = pageData;
      }
    );
  }

  function animatePage(page, deltaX, newPos) {
    let duration = 1000;
    let frontPosLeftBounds = 0;
    let frontPosTopBounds = 20; //Percentage

    if (newPos != 0) {
      duration = newPos * 300;
    }

    if ($state.isMobile) {
      if (newPos == 20) {
        page.style.overflowX = "auto";
      } else {
        page.style.overflowX = "unset";
      }
    } else {
      if (newPos == 0) {
        page.style.overflowX = "auto";
      } else {
        page.style.overflowX = "unset";
      }
    }

    let translateFirst = $state.isMobile
      ? `translate(0, 100%)`
      : `translate(${deltaX}%, 0)`;
    let translateSecond = $state.isMobile
      ? `translate(0, ${newPos}%)`
      : `translate(${newPos}%, 0)`;

    page.animate(
      [
        // keyframes
        {
          transform: translateFirst
        },
        {
          transform: translateSecond
        }
      ],
      {
        // timing options
        duration: duration,
        easing: "cubic-bezier(0.075, 0.82, 0.165, 1)",
        fill: "both"
      }
    );
  }

  //Initialising page by positioning page components and mapping positions
  function initialisePages() {
    allPageComponents = [].slice.call(
      document.querySelectorAll(".page-component")
    );
    let spacerDistance = $state.isMobile ? 5 : 3;
    if (allPageComponents) {
      allPageComponents.forEach((page, index) => {
        let pageColor = page.attributes.class.nodeValue.split(" ")[1];
        let pageLeftBounds =
          (allPageComponents.length - (index + 1)) * spacerDistance;
        pageSlots[index] = {
          slot: index,
          zIndex: index,
          boundsLeft: pageLeftBounds
        };
        pageComponentOrder[index] = {
          pageId: page.id,
          slot: index,
          color: pageColor
        };
        page.style.zIndex = $state.isMobile
          ? allPageComponents.length - index
          : index;
        animatePage(page, 0, pageLeftBounds);
      });
    }

    setTimeout(function() {
      isStickersVisible = true;
    }, 800);

    console.log("Hey 👋🏼 This site was designed and built by me, Valerie. Why don't you have a look around? 🌈");
  }

  function updatePages(e) {
    let activePageId = e.detail.pageId;
    let currentPosActivePage = pageComponentOrder
      .map(el => el.pageId)
      .indexOf(`${activePageId}`);
    let frontPos = $state.isMobile ? 0 : pageComponentOrder.length - 1;

    let newPageComponentOrder = returnShuffledArray(
      pageComponentOrder,
      currentPosActivePage,
      frontPos
    );
    newPageComponentOrder.map((page, i) => (page.slot = i));

    newPageComponentOrder.forEach((entry, index) => {
      let prevSlot = pageComponentOrder
        .map(page => page.pageId)
        .indexOf(entry.pageId);
      let newSlot = index;
      let prevBoundsLeft = pageSlots[prevSlot].boundsLeft;
      let newBoundsLeft = pageSlots[newSlot].boundsLeft;
      let deltaX = prevBoundsLeft - newBoundsLeft;
      let newPos = prevBoundsLeft - deltaX;
      let pageEl = document.getElementById(entry.pageId);
      pageEl.style.zIndex = $state.isMobile
        ? pageComponentOrder.length - newSlot
        : newSlot;
      if (prevSlot != newSlot) {
        animatePage(pageEl, deltaX, newPos);
      }
    });
    pageComponentOrder = newPageComponentOrder;
  }

  // //Initialising Storyblok
  window.storyblok.init({
    accessToken: "Ncq7dxRQiE5ybkRt3iyukgtt"
  });

  //Listen to changes of the content
  window.storyblok.on("change", function() {
    getAllStories();
  });
  window.storyblok.on("published", function() {
    getAllStories();
  });

  onMount(() => {
    let isMobile = window.innerWidth < 700 ? true : false;
    state.set({
      isMobile: isMobile
    });
  });

  window.addEventListener("resize", function() {
    let isMobile = window.innerWidth < 700 ? true : false;
    if ($state.isMobile !== isMobile) {
      state.set({
        isMobile: isMobile
      });
      initialisePages();
    }
  });

  getAllStories();
  setTimeout(initialisePages, 600);
</script>

<style>
  .global-wrapper {
    position: relative;
    height: 100vh;
    width: 100%;
    display: block;
    overflow: hidden;
  }
</style>

<div class="global-wrapper">
  {#if !$state.isMobile}
    {#each stickerItems as item}
      <StickerComponent
        isVisible={isStickersVisible}
        imagesrc={item.img}
        position={item.position}
        rotation={item.rotation}
        delay={item.delay}
        isButton={item.isButton} />
    {/each}
  {/if}
  {#if pageData}
    {#each visibleInNavPages as page, i}
      <PageComponent
        data={page}
        on:changepage={e => updatePages(e)}
        isMobile={$state.isMobile}
        index={i} />
    {/each}
  {/if}
</div>
